import React from 'react';
import { emailMailtoHref } from '../utils/contactLinks';
import './ContactLink.css';

type EmailLinkProps = {
  email?: string | null;
  className?: string;
  fallback?: React.ReactNode;
};

const EmailLink: React.FC<EmailLinkProps> = ({ email, className = '', fallback = '—' }) => {
  const display = String(email ?? '').trim();
  if (!display) {
    return <>{fallback}</>;
  }
  const href = emailMailtoHref(display);
  if (!href) {
    return <span className={className}>{display}</span>;
  }
  return (
    <a href={href} className={`contact-link contact-link--email ${className}`.trim()}>
      {display}
    </a>
  );
};

export default EmailLink;
